import React, {useEffect} from 'react';
import {useFormik} from 'formik';
import {decode} from 'js-base64';
import {useSignIn, useIsAuthenticated, useSignOut} from "react-auth-kit";
import {isDealerSite, requestApi, requestLoader, showAlertAutoDis, validateUser} from "../../utils/utils";
import {useLocation} from "react-router-dom";
import {Box} from "@mui/material";
import GoogleLogin from '../../components/Buttons/GoogleLogin';
import GoogleAuth from '../../components/Buttons/GoogleAuth';

const LoginPageTest = ({history}) => {
    const signIn = useSignIn();
    const isAuthenticated = useIsAuthenticated();
    const signOut = useSignOut();
    const {search} = useLocation();

    const searchParams = new URLSearchParams(search);
    const redirect = searchParams.get("redirect");

    useEffect(() => {
        verifyAuth().catch();
    }, []);

    const verifyAuth = async () => {
        if (isAuthenticated()) {
            const data = await validateUser();
            if (data.status === 'success' && !data.validate)
                return signOut();
            history.push(redirect || `/booking/my-bookings`);
        }
    }


    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: async (values) => {
            try {
                const {data} = await requestApi('/customer/login', 'POST', values);

                const token = data['token'].split('.');
                const user = JSON.parse(decode(token[1]));

                const jwtParams = {
                    token: data['token'],
                    expiresIn: data['expires_in'],
                    tokenType: data['token_type'],
                    authState: {
                        id: user['id'],
                        firstName: user['firstname'],
                        lastName: user['lastname'],
                        email: user['email'],
                    },
                };
                if (isDealerSite())
                    jwtParams.authState.commission = user['commission'];

                if (signIn(jwtParams)) {
                    await loginBack(values);
                    history.push(redirect || `/booking/my-bookings`);
                } else {
                    showAlertAutoDis({title: 'Error', text: 'Unable to login. Please try again.'});
                }

                // const user = data['token'];
                // localStorage.setItem('user', user);
            } catch (data) {
                const {data: {data: {title, message: text}}} = data;
                showAlertAutoDis({title, text});
            }
        },
    });

    const loginBack = async (values) => {
        const {data: logBack} = await requestLoader('booking/loginBack', values);
        // console.log(logBack);
    };

    return (
        <div className="wrapper" style={{paddingTop: 50}}>
            <div className="auth_pages nautilus-login">
                <h1 style={{fontSize: '3.2rem'}}>{isDealerSite() ? 'Thank you for visiting our dealer support page' : 'Welcome Back!'}</h1>
                <p className="text-left">Please login.
                    <br/>
                    {isDealerSite() ? '' :
                        "If you don't have a login, you will be asked to create one once you decide to book a trip."}
                </p>
                <form onSubmit={formik.handleSubmit}>
                    <div className="login-container">
                        <div className="col-100 text-left">
                            <label htmlFor="email">Email Address</label>
                            <input type="text" onChange={formik.handleChange}
                                   value={formik.values.email} name="email" id="email"
                                   placeholder="Email"/>
                        </div>
                        <div className="col-100 text-left">
                            <label htmlFor="password">Password</label>
                            <input type="password" name="password" onChange={formik.handleChange}
                                   value={formik.values.password} id="password" placeholder="Password"/>
                        </div>

                        <div className="spacer"/>

                        <div className="submit" style={{marginBottom: '10px'}}>
                            <input style={{padding: '8px 30px', letterSpacing: '0.1em', fontWeight: '600'}}
                                   type="submit" name="submit" value="Login" className="gold-button"/>
                        </div>
                        {isDealerSite() && (<div className="center">
                            <small>
                                Don't have a login? <a href={`${window['appBasename']}/contact`}>Apply here for a dealer
                                account</a>
                            </small>
                        </div>)}
                        <div className="center">
                            <small> <a href="forgot_password">Forgot your password?</a></small>
                        </div>
						<Box
							width="100%"
							display="flex"
							flexDirection="column"
							alignItems="center"
						>
							
							<GoogleLogin width="100%">Sign in with Google</GoogleLogin>
							
							<GoogleAuth width="100%">Sign up with Google</GoogleAuth>
						</Box>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPageTest;